import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-DataDog',
    templateUrl: './DataDog.component.html'
})
export class DataDogComponent implements OnInit {

    consumerID: string;
    host = '127.0.0.1';
    port = 8125;
    prefix = 'kong';
    metrics: [];

    data = {
        'consumerID' : this.consumerID,
        'host' : this.host,
        'port' : this.port,
        'prefix' : this.prefix,
        'metrics' : this.metrics,
        'plugin' : 'datadog'
    };
    constructor() { }

    DataDog() {
    }

    ngOnInit() {
    }

}
